import {getMsgDetails, getMsgSummary} from 'crm/services/group-msg'
import {parse} from 'qs'
import createModel from 'utils/model'

const params = {
    keyword: undefined,
    user_id: undefined,
    department_id: undefined,
    status: undefined,
    limit: 10,
    offset: 0,
}

export default createModel({
    namespace: 'crm_groupMsgDetails',

    state: {
        params: {
            ...params,
        },
        list: [],
        total: 0,
        current: 1,
        summaryArr: [],
        tableData: {},
    },

    effects: {
        *getMsgDetailsTable({payload}, {select, call, put}) {
            const {tableData} = yield select(({crm_groupMsgDetails}) => crm_groupMsgDetails)

            const newParams = {
                offset: tableData.pagination.pageSize * (tableData.pagination.current - 1),
                limit: tableData.pagination.pageSize,
                ...tableData.params,
            }

            const res = yield call(getMsgDetails, {id: payload.id, params: parse(newParams)})

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableData.dataSource = res.data
                    draft.tableData.pagination.total = res?.pagination?.rows_found ?? 0
                },
            })
        },

        *getMsgDetails({payload, callback}, {select, call, put}) {
            // eslint-disable-next-line no-shadow
            let params = yield select(({crm_groupMsgDetails}) => crm_groupMsgDetails.params)
            params = {...params, ...payload.params}
            if (payload.page) {
                params.offset = params.limit * (payload.page - 1)
            }
            const data = yield call(getMsgDetails, {id: payload.id, params: parse(params)})

            if (data && data.data) {
                yield put({
                    type: 'setProperty',
                    payload: {
                        list: data.data,
                        params,
                        total: data.pagination.rows_found,
                        current: payload.page === undefined ? 1 : payload.page,
                    },
                })
                callback && callback(data.data)
            }
        },

        *getMsgSummary({payload}, {call, put}) {
            const res = yield call(getMsgSummary, payload)

            if (res && res.data) {
                yield put({
                    type: 'setProperty',
                    payload: {
                        summaryArr: res.data,
                    },
                })
            }
        },
    },

    reducers: {
        resetParams(state) {
            return {...state, params}
        },
    },
})
